import { createFileRoute, stripSearchParams } from '@tanstack/react-router'

import { TeamPerformancePage } from '@/features/performance/performance-page'
import {
  TEAM_PERFORMANCE_SEARCH_DEFAULTS,
  teamPerformanceSearchSchema,
} from '@/features/performance/search'

/**
 * /team-performance —— 团队业绩(销售视角看组织数据)。
 *
 * 期间(本月 / 全部)与员工表排序都走 search params:zod 校验、非法值降级不白屏,
 * 等于默认值的参数由 stripSearchParams 摘掉,裸 /team-performance 就是「本月 + 签约额降序」。
 * 页面实现见 features/performance/。
 */
export const Route = createFileRoute('/_authed/team-performance/')({
  validateSearch: teamPerformanceSearchSchema,
  search: {
    middlewares: [stripSearchParams(TEAM_PERFORMANCE_SEARCH_DEFAULTS)],
  },
  component: TeamPerformancePage,
})
